module.exports = __webpack_public_path__ + "img/il.0253ed33.png";